import { createApp } from 'vue';
import PsdToPngConverter from '@/Components/PsdToPngConverter.vue';
import '@styles/app.css';

createApp(PsdToPngConverter).mount('#psd-to-png-converter');
